/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddUserModel,
    AddUserModelFromJSON,
    AddUserModelToJSON,
} from '../models/AddUserModel';
import {
    type ApplicationRole,
    ApplicationRoleFromJSON,
    ApplicationRoleToJSON,
} from '../models/ApplicationRole';
import {
    type ApplicationUser,
    ApplicationUserFromJSON,
    ApplicationUserToJSON,
} from '../models/ApplicationUser';
import {
    type Claim,
    ClaimFromJSON,
    ClaimToJSON,
} from '../models/Claim';
import {
    type DataSourceLoadOptions,
    DataSourceLoadOptionsFromJSON,
    DataSourceLoadOptionsToJSON,
} from '../models/DataSourceLoadOptions';
import {
    type IdentityResult,
    IdentityResultFromJSON,
    IdentityResultToJSON,
} from '../models/IdentityResult';
import {
    type ImpersonateResult,
    ImpersonateResultFromJSON,
    ImpersonateResultToJSON,
} from '../models/ImpersonateResult';
import {
    type LoadResult,
    LoadResultFromJSON,
    LoadResultToJSON,
} from '../models/LoadResult';
import {
    type LoginInputModel,
    LoginInputModelFromJSON,
    LoginInputModelToJSON,
} from '../models/LoginInputModel';
import {
    type OrganisationInfo,
    OrganisationInfoFromJSON,
    OrganisationInfoToJSON,
} from '../models/OrganisationInfo';
import {
    type P4mClaim,
    P4mClaimFromJSON,
    P4mClaimToJSON,
} from '../models/P4mClaim';
import {
    type UpdateUserModel,
    UpdateUserModelFromJSON,
    UpdateUserModelToJSON,
} from '../models/UpdateUserModel';

export interface AccountAddRoleIdClientPostRequest {
    idClient: string;
    applicationRole: ApplicationRole;
}

export interface AccountAddUserPostRequest {
    addUserModel: AddUserModel;
}

export interface AccountChangePasswordUserIdUserPostRequest {
    idUser: string;
    oldPassworc: string;
    newPassword: string;
}

export interface AccountDeleteRoleRoleIdPostRequest {
    roleId: string;
}

export interface AccountDeleteUserIdUserPostRequest {
    idUser: string;
}

export interface AccountFindObjectsADFindStrGetRequest {
    findStr: string;
}

export interface AccountGetGroupADFindStrGetRequest {
    findStr: string;
}

export interface AccountGetRoleRoleIdGetRequest {
    roleId: string;
}

export interface AccountGetRolesByUserUserIdGetRequest {
    userId: string;
}

export interface AccountGetRolesPostRequest {
    dataSourceLoadOptions?: DataSourceLoadOptions;
}

export interface AccountGetUserByIdIdUserGetRequest {
    idUser: string;
}

export interface AccountGetUserByLoginLoginGetRequest {
    login: string;
}

export interface AccountGetUserClaimsIdClientIdUserGetRequest {
    idClient: string;
    idUser: string;
}

export interface AccountGetUserOrganisationUserIdGetRequest {
    userId: string;
}

export interface AccountGetUsersByRoleRoleIdGetRequest {
    roleId: string;
}

export interface AccountGetUsersDXPostRequest {
    dataSourceLoadOptions?: DataSourceLoadOptions;
}

export interface AccountImpersonateGetRequest {
    impUserId: string;
    redirectUrl?: string;
}

export interface AccountImpersonateImpUserIdPostRequest {
    impUserId: string;
}

export interface AccountImpersonateLogoutGetRequest {
    clientId?: string;
}

export interface AccountListUserLayoutsIdUserGetRequest {
    idUser: string;
}

export interface AccountLoginPostRequest {
    loginInputModel: LoginInputModel;
    button?: string;
}

export interface AccountLogoutGetRequest {
    logoutId?: string;
}

export interface AccountUpdateRoleIdClientRoleIdPostRequest {
    idClient: string;
    roleId: string;
    applicationRole?: ApplicationRole;
}

export interface AccountUpdateUserClaimsIdClientIdUserPostRequest {
    idClient: string;
    idUser: string;
    p4mClaim: Array<P4mClaim>;
}

export interface AccountUpdateUserIdUserPostRequest {
    idUser: string;
    updateUserModel: UpdateUserModel;
}

export interface AccountUpdateUserRolesIdUserPostRequest {
    idUser: string;
    requestBody: Array<string>;
}

export interface AccountUpdateUsersRangePostRequest {
    updateUserModel: Array<UpdateUserModel>;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Creates request options for accountAddRoleIdClientPost without sending the request
     */
    async accountAddRoleIdClientPostRequestOpts(requestParameters: AccountAddRoleIdClientPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling accountAddRoleIdClientPost().'
            );
        }

        if (requestParameters['applicationRole'] == null) {
            throw new runtime.RequiredError(
                'applicationRole',
                'Required parameter "applicationRole" was null or undefined when calling accountAddRoleIdClientPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/AddRole/{idClient}`;
        urlPath = urlPath.replace('{idClient}', encodeURIComponent(String(requestParameters['idClient'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRoleToJSON(requestParameters['applicationRole']),
        };
    }

    /**
     * Добавление роли
     */
    async accountAddRoleIdClientPostRaw(requestParameters: AccountAddRoleIdClientPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.accountAddRoleIdClientPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Добавление роли
     */
    async accountAddRoleIdClientPost(requestParameters: AccountAddRoleIdClientPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.accountAddRoleIdClientPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountAddUserPost without sending the request
     */
    async accountAddUserPostRequestOpts(requestParameters: AccountAddUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['addUserModel'] == null) {
            throw new runtime.RequiredError(
                'addUserModel',
                'Required parameter "addUserModel" was null or undefined when calling accountAddUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/AddUser`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserModelToJSON(requestParameters['addUserModel']),
        };
    }

    /**
     * Добавление пользователя
     */
    async accountAddUserPostRaw(requestParameters: AccountAddUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.accountAddUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Добавление пользователя
     */
    async accountAddUserPost(requestParameters: AccountAddUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.accountAddUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountChangePasswordUserIdUserPost without sending the request
     */
    async accountChangePasswordUserIdUserPostRequestOpts(requestParameters: AccountChangePasswordUserIdUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountChangePasswordUserIdUserPost().'
            );
        }

        if (requestParameters['oldPassworc'] == null) {
            throw new runtime.RequiredError(
                'oldPassworc',
                'Required parameter "oldPassworc" was null or undefined when calling accountChangePasswordUserIdUserPost().'
            );
        }

        if (requestParameters['newPassword'] == null) {
            throw new runtime.RequiredError(
                'newPassword',
                'Required parameter "newPassword" was null or undefined when calling accountChangePasswordUserIdUserPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['oldPassworc'] != null) {
            queryParameters['OldPassworc'] = requestParameters['oldPassworc'];
        }

        if (requestParameters['newPassword'] != null) {
            queryParameters['NewPassword'] = requestParameters['newPassword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/ChangePasswordUser/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Смена пароля пользователя
     */
    async accountChangePasswordUserIdUserPostRaw(requestParameters: AccountChangePasswordUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdentityResult>> {
        const requestOptions = await this.accountChangePasswordUserIdUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityResultFromJSON(jsonValue));
    }

    /**
     * Смена пароля пользователя
     */
    async accountChangePasswordUserIdUserPost(requestParameters: AccountChangePasswordUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdentityResult> {
        const response = await this.accountChangePasswordUserIdUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountDeleteRoleRoleIdPost without sending the request
     */
    async accountDeleteRoleRoleIdPostRequestOpts(requestParameters: AccountDeleteRoleRoleIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling accountDeleteRoleRoleIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/DeleteRole/{roleId}`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Удаление роли
     */
    async accountDeleteRoleRoleIdPostRaw(requestParameters: AccountDeleteRoleRoleIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdentityResult>> {
        const requestOptions = await this.accountDeleteRoleRoleIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityResultFromJSON(jsonValue));
    }

    /**
     * Удаление роли
     */
    async accountDeleteRoleRoleIdPost(requestParameters: AccountDeleteRoleRoleIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdentityResult> {
        const response = await this.accountDeleteRoleRoleIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountDeleteUserIdUserPost without sending the request
     */
    async accountDeleteUserIdUserPostRequestOpts(requestParameters: AccountDeleteUserIdUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountDeleteUserIdUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/DeleteUser/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Удаление пользователя
     */
    async accountDeleteUserIdUserPostRaw(requestParameters: AccountDeleteUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdentityResult>> {
        const requestOptions = await this.accountDeleteUserIdUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityResultFromJSON(jsonValue));
    }

    /**
     * Удаление пользователя
     */
    async accountDeleteUserIdUserPost(requestParameters: AccountDeleteUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdentityResult> {
        const response = await this.accountDeleteUserIdUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountFindObjectsADFindStrGet without sending the request
     */
    async accountFindObjectsADFindStrGetRequestOpts(requestParameters: AccountFindObjectsADFindStrGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findStr'] == null) {
            throw new runtime.RequiredError(
                'findStr',
                'Required parameter "findStr" was null or undefined when calling accountFindObjectsADFindStrGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/FindObjectsAD/{findStr}`;
        urlPath = urlPath.replace('{findStr}', encodeURIComponent(String(requestParameters['findStr'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Произвольный запрос AD
     */
    async accountFindObjectsADFindStrGetRaw(requestParameters: AccountFindObjectsADFindStrGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountFindObjectsADFindStrGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Произвольный запрос AD
     */
    async accountFindObjectsADFindStrGet(requestParameters: AccountFindObjectsADFindStrGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountFindObjectsADFindStrGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountGetGroupADFindStrGet without sending the request
     */
    async accountGetGroupADFindStrGetRequestOpts(requestParameters: AccountGetGroupADFindStrGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findStr'] == null) {
            throw new runtime.RequiredError(
                'findStr',
                'Required parameter "findStr" was null or undefined when calling accountGetGroupADFindStrGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetGroupAD/{findStr}`;
        urlPath = urlPath.replace('{findStr}', encodeURIComponent(String(requestParameters['findStr'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка групп AD
     */
    async accountGetGroupADFindStrGetRaw(requestParameters: AccountGetGroupADFindStrGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountGetGroupADFindStrGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Получение списка групп AD
     */
    async accountGetGroupADFindStrGet(requestParameters: AccountGetGroupADFindStrGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountGetGroupADFindStrGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountGetListUsersGet without sending the request
     */
    async accountGetListUsersGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetListUsers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetListUsersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationUser>>> {
        const requestOptions = await this.accountGetListUsersGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationUserFromJSON));
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetListUsersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationUser>> {
        const response = await this.accountGetListUsersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetRoleRoleIdGet without sending the request
     */
    async accountGetRoleRoleIdGetRequestOpts(requestParameters: AccountGetRoleRoleIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling accountGetRoleRoleIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetRole/{roleId}`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение роли с клайм
     */
    async accountGetRoleRoleIdGetRaw(requestParameters: AccountGetRoleRoleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationRole>> {
        const requestOptions = await this.accountGetRoleRoleIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationRoleFromJSON(jsonValue));
    }

    /**
     * Получение роли с клайм
     */
    async accountGetRoleRoleIdGet(requestParameters: AccountGetRoleRoleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationRole> {
        const response = await this.accountGetRoleRoleIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetRolesByUserUserIdGet without sending the request
     */
    async accountGetRolesByUserUserIdGetRequestOpts(requestParameters: AccountGetRolesByUserUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling accountGetRolesByUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetRolesByUser/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка ролей пользователя
     */
    async accountGetRolesByUserUserIdGetRaw(requestParameters: AccountGetRolesByUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.accountGetRolesByUserUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Получение списка ролей пользователя
     */
    async accountGetRolesByUserUserIdGet(requestParameters: AccountGetRolesByUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.accountGetRolesByUserUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetRolesPost without sending the request
     */
    async accountGetRolesPostRequestOpts(requestParameters: AccountGetRolesPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetRoles`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Получение списка ролей с клайм
     */
    async accountGetRolesPostRaw(requestParameters: AccountGetRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadResult>> {
        const requestOptions = await this.accountGetRolesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadResultFromJSON(jsonValue));
    }

    /**
     * Получение списка ролей с клайм
     */
    async accountGetRolesPost(requestParameters: AccountGetRolesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadResult> {
        const response = await this.accountGetRolesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUserAuthClaimsGet without sending the request
     */
    async accountGetUserAuthClaimsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUserAuthClaims`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка клайм модуля авторизации текущего пользователя
     */
    async accountGetUserAuthClaimsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Claim>>> {
        const requestOptions = await this.accountGetUserAuthClaimsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimFromJSON));
    }

    /**
     * Получение списка клайм модуля авторизации текущего пользователя
     */
    async accountGetUserAuthClaimsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Claim>> {
        const response = await this.accountGetUserAuthClaimsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUserByIdIdUserGet without sending the request
     */
    async accountGetUserByIdIdUserGetRequestOpts(requestParameters: AccountGetUserByIdIdUserGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountGetUserByIdIdUserGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUserById/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Возвращает пользователя по ИД
     */
    async accountGetUserByIdIdUserGetRaw(requestParameters: AccountGetUserByIdIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationUser>> {
        const requestOptions = await this.accountGetUserByIdIdUserGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationUserFromJSON(jsonValue));
    }

    /**
     * Возвращает пользователя по ИД
     */
    async accountGetUserByIdIdUserGet(requestParameters: AccountGetUserByIdIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationUser> {
        const response = await this.accountGetUserByIdIdUserGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUserByLoginLoginGet without sending the request
     */
    async accountGetUserByLoginLoginGetRequestOpts(requestParameters: AccountGetUserByLoginLoginGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['login'] == null) {
            throw new runtime.RequiredError(
                'login',
                'Required parameter "login" was null or undefined when calling accountGetUserByLoginLoginGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUserByLogin/{login}`;
        urlPath = urlPath.replace('{login}', encodeURIComponent(String(requestParameters['login'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Возвращает пользователя по логину Name|Email
     */
    async accountGetUserByLoginLoginGetRaw(requestParameters: AccountGetUserByLoginLoginGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.accountGetUserByLoginLoginGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Возвращает пользователя по логину Name|Email
     */
    async accountGetUserByLoginLoginGet(requestParameters: AccountGetUserByLoginLoginGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.accountGetUserByLoginLoginGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUserClaimsIdClientIdUserGet without sending the request
     */
    async accountGetUserClaimsIdClientIdUserGetRequestOpts(requestParameters: AccountGetUserClaimsIdClientIdUserGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling accountGetUserClaimsIdClientIdUserGet().'
            );
        }

        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountGetUserClaimsIdClientIdUserGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUserClaims/{idClient}/{idUser}`;
        urlPath = urlPath.replace('{idClient}', encodeURIComponent(String(requestParameters['idClient'])));
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка клайм пользователя
     */
    async accountGetUserClaimsIdClientIdUserGetRaw(requestParameters: AccountGetUserClaimsIdClientIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Claim>>> {
        const requestOptions = await this.accountGetUserClaimsIdClientIdUserGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimFromJSON));
    }

    /**
     * Получение списка клайм пользователя
     */
    async accountGetUserClaimsIdClientIdUserGet(requestParameters: AccountGetUserClaimsIdClientIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Claim>> {
        const response = await this.accountGetUserClaimsIdClientIdUserGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUserOrganisationUserIdGet without sending the request
     */
    async accountGetUserOrganisationUserIdGetRequestOpts(requestParameters: AccountGetUserOrganisationUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling accountGetUserOrganisationUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUserOrganisation/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение информации об участнке пользователя
     */
    async accountGetUserOrganisationUserIdGetRaw(requestParameters: AccountGetUserOrganisationUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganisationInfo>> {
        const requestOptions = await this.accountGetUserOrganisationUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationInfoFromJSON(jsonValue));
    }

    /**
     * Получение информации об участнке пользователя
     */
    async accountGetUserOrganisationUserIdGet(requestParameters: AccountGetUserOrganisationUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganisationInfo> {
        const response = await this.accountGetUserOrganisationUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUsersByRoleRoleIdGet without sending the request
     */
    async accountGetUsersByRoleRoleIdGetRequestOpts(requestParameters: AccountGetUsersByRoleRoleIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling accountGetUsersByRoleRoleIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUsersByRole/{roleId}`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка пользователей, принадлежащих роли
     */
    async accountGetUsersByRoleRoleIdGetRaw(requestParameters: AccountGetUsersByRoleRoleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationUser>>> {
        const requestOptions = await this.accountGetUsersByRoleRoleIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationUserFromJSON));
    }

    /**
     * Получение списка пользователей, принадлежащих роли
     */
    async accountGetUsersByRoleRoleIdGet(requestParameters: AccountGetUsersByRoleRoleIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationUser>> {
        const response = await this.accountGetUsersByRoleRoleIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUsersDXPost without sending the request
     */
    async accountGetUsersDXPostRequestOpts(requestParameters: AccountGetUsersDXPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUsersDX`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetUsersDXPostRaw(requestParameters: AccountGetUsersDXPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadResult>> {
        const requestOptions = await this.accountGetUsersDXPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadResultFromJSON(jsonValue));
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetUsersDXPost(requestParameters: AccountGetUsersDXPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadResult> {
        const response = await this.accountGetUsersDXPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountGetUsersGet without sending the request
     */
    async accountGetUsersGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/GetUsers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetUsersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationUser>>> {
        const requestOptions = await this.accountGetUsersGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationUserFromJSON));
    }

    /**
     * Возвращает список всех пользователей
     */
    async accountGetUsersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationUser>> {
        const response = await this.accountGetUsersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountImpersonateGet without sending the request
     */
    async accountImpersonateGetRequestOpts(requestParameters: AccountImpersonateGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['impUserId'] == null) {
            throw new runtime.RequiredError(
                'impUserId',
                'Required parameter "impUserId" was null or undefined when calling accountImpersonateGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['impUserId'] != null) {
            queryParameters['impUserId'] = requestParameters['impUserId'];
        }

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirectUrl'] = requestParameters['redirectUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/Impersonate`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Вход под другим пользователем
     */
    async accountImpersonateGetRaw(requestParameters: AccountImpersonateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountImpersonateGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Вход под другим пользователем
     */
    async accountImpersonateGet(requestParameters: AccountImpersonateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountImpersonateGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountImpersonateImpUserIdPost without sending the request
     */
    async accountImpersonateImpUserIdPostRequestOpts(requestParameters: AccountImpersonateImpUserIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['impUserId'] == null) {
            throw new runtime.RequiredError(
                'impUserId',
                'Required parameter "impUserId" was null or undefined when calling accountImpersonateImpUserIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/Impersonate/{impUserId}`;
        urlPath = urlPath.replace('{impUserId}', encodeURIComponent(String(requestParameters['impUserId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Вход под другим пользователем (Auth)
     */
    async accountImpersonateImpUserIdPostRaw(requestParameters: AccountImpersonateImpUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImpersonateResult>> {
        const requestOptions = await this.accountImpersonateImpUserIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImpersonateResultFromJSON(jsonValue));
    }

    /**
     * Вход под другим пользователем (Auth)
     */
    async accountImpersonateImpUserIdPost(requestParameters: AccountImpersonateImpUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImpersonateResult> {
        const response = await this.accountImpersonateImpUserIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountImpersonateLogoutGet without sending the request
     */
    async accountImpersonateLogoutGetRequestOpts(requestParameters: AccountImpersonateLogoutGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/Impersonate/Logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Выход из-под другого пользователя
     */
    async accountImpersonateLogoutGetRaw(requestParameters: AccountImpersonateLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountImpersonateLogoutGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Выход из-под другого пользователя
     */
    async accountImpersonateLogoutGet(requestParameters: AccountImpersonateLogoutGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountImpersonateLogoutGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountListUserLayoutsIdUserGet without sending the request
     */
    async accountListUserLayoutsIdUserGetRequestOpts(requestParameters: AccountListUserLayoutsIdUserGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountListUserLayoutsIdUserGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/ListUserLayouts/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Возвращает список рабочих столов пользователя всех модулей
     */
    async accountListUserLayoutsIdUserGetRaw(requestParameters: AccountListUserLayoutsIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<string>; }>> {
        const requestOptions = await this.accountListUserLayoutsIdUserGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Возвращает список рабочих столов пользователя всех модулей
     */
    async accountListUserLayoutsIdUserGet(requestParameters: AccountListUserLayoutsIdUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<string>; }> {
        const response = await this.accountListUserLayoutsIdUserGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountLoginPost without sending the request
     */
    async accountLoginPostRequestOpts(requestParameters: AccountLoginPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginInputModel'] == null) {
            throw new runtime.RequiredError(
                'loginInputModel',
                'Required parameter "loginInputModel" was null or undefined when calling accountLoginPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['button'] != null) {
            queryParameters['button'] = requestParameters['button'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/Login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginInputModelToJSON(requestParameters['loginInputModel']),
        };
    }

    /**
     * Вход пользователя в модуль
     */
    async accountLoginPostRaw(requestParameters: AccountLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountLoginPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Вход пользователя в модуль
     */
    async accountLoginPost(requestParameters: AccountLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountLoginPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountLogoutGet without sending the request
     */
    async accountLogoutGetRequestOpts(requestParameters: AccountLogoutGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['logoutId'] != null) {
            queryParameters['logoutId'] = requestParameters['logoutId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/Logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Выход пользователя из модуля (legacy URL, перенаправляет на ui-api/auth/logout).
     */
    async accountLogoutGetRaw(requestParameters: AccountLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountLogoutGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Выход пользователя из модуля (legacy URL, перенаправляет на ui-api/auth/logout).
     */
    async accountLogoutGet(requestParameters: AccountLogoutGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountLogoutGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountSyncADGet without sending the request
     */
    async accountSyncADGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/SyncAD`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Синхронизация пользователей AD
     */
    async accountSyncADGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountSyncADGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Синхронизация пользователей AD
     */
    async accountSyncADGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountSyncADGetRaw(initOverrides);
    }

    /**
     * Creates request options for accountUpdateRoleIdClientRoleIdPost without sending the request
     */
    async accountUpdateRoleIdClientRoleIdPostRequestOpts(requestParameters: AccountUpdateRoleIdClientRoleIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling accountUpdateRoleIdClientRoleIdPost().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling accountUpdateRoleIdClientRoleIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/UpdateRole/{idClient}/{roleId}`;
        urlPath = urlPath.replace('{idClient}', encodeURIComponent(String(requestParameters['idClient'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRoleToJSON(requestParameters['applicationRole']),
        };
    }

    /**
     * Обновление роли
     */
    async accountUpdateRoleIdClientRoleIdPostRaw(requestParameters: AccountUpdateRoleIdClientRoleIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.accountUpdateRoleIdClientRoleIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Обновление роли
     */
    async accountUpdateRoleIdClientRoleIdPost(requestParameters: AccountUpdateRoleIdClientRoleIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.accountUpdateRoleIdClientRoleIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountUpdateUserClaimsIdClientIdUserPost without sending the request
     */
    async accountUpdateUserClaimsIdClientIdUserPostRequestOpts(requestParameters: AccountUpdateUserClaimsIdClientIdUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling accountUpdateUserClaimsIdClientIdUserPost().'
            );
        }

        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountUpdateUserClaimsIdClientIdUserPost().'
            );
        }

        if (requestParameters['p4mClaim'] == null) {
            throw new runtime.RequiredError(
                'p4mClaim',
                'Required parameter "p4mClaim" was null or undefined when calling accountUpdateUserClaimsIdClientIdUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/UpdateUserClaims/{idClient}/{idUser}`;
        urlPath = urlPath.replace('{idClient}', encodeURIComponent(String(requestParameters['idClient'])));
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['p4mClaim']!.map(P4mClaimToJSON),
        };
    }

    /**
     * Обновление клайм пользователя
     */
    async accountUpdateUserClaimsIdClientIdUserPostRaw(requestParameters: AccountUpdateUserClaimsIdClientIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountUpdateUserClaimsIdClientIdUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновление клайм пользователя
     */
    async accountUpdateUserClaimsIdClientIdUserPost(requestParameters: AccountUpdateUserClaimsIdClientIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountUpdateUserClaimsIdClientIdUserPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountUpdateUserIdUserPost without sending the request
     */
    async accountUpdateUserIdUserPostRequestOpts(requestParameters: AccountUpdateUserIdUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountUpdateUserIdUserPost().'
            );
        }

        if (requestParameters['updateUserModel'] == null) {
            throw new runtime.RequiredError(
                'updateUserModel',
                'Required parameter "updateUserModel" was null or undefined when calling accountUpdateUserIdUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/UpdateUser/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserModelToJSON(requestParameters['updateUserModel']),
        };
    }

    /**
     * Обновление данных пользователя
     */
    async accountUpdateUserIdUserPostRaw(requestParameters: AccountUpdateUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountUpdateUserIdUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновление данных пользователя
     */
    async accountUpdateUserIdUserPost(requestParameters: AccountUpdateUserIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountUpdateUserIdUserPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountUpdateUserRolesIdUserPost without sending the request
     */
    async accountUpdateUserRolesIdUserPostRequestOpts(requestParameters: AccountUpdateUserRolesIdUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idUser'] == null) {
            throw new runtime.RequiredError(
                'idUser',
                'Required parameter "idUser" was null or undefined when calling accountUpdateUserRolesIdUserPost().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling accountUpdateUserRolesIdUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/UpdateUserRoles/{idUser}`;
        urlPath = urlPath.replace('{idUser}', encodeURIComponent(String(requestParameters['idUser'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Обновление ролей пользователя
     */
    async accountUpdateUserRolesIdUserPostRaw(requestParameters: AccountUpdateUserRolesIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountUpdateUserRolesIdUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновление ролей пользователя
     */
    async accountUpdateUserRolesIdUserPost(requestParameters: AccountUpdateUserRolesIdUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountUpdateUserRolesIdUserPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountUpdateUsersRangePost without sending the request
     */
    async accountUpdateUsersRangePostRequestOpts(requestParameters: AccountUpdateUsersRangePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateUserModel'] == null) {
            throw new runtime.RequiredError(
                'updateUserModel',
                'Required parameter "updateUserModel" was null or undefined when calling accountUpdateUsersRangePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/UpdateUsersRange`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateUserModel']!.map(UpdateUserModelToJSON),
        };
    }

    /**
     * Обновление данных нескольких пользователей
     */
    async accountUpdateUsersRangePostRaw(requestParameters: AccountUpdateUsersRangePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountUpdateUsersRangePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновление данных нескольких пользователей
     */
    async accountUpdateUsersRangePost(requestParameters: AccountUpdateUsersRangePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountUpdateUsersRangePostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for accountValidationUserADGet without sending the request
     */
    async accountValidationUserADGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/Account/ValidationUserAD`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Валидация пользователя AD и генерация его токена
     */
    async accountValidationUserADGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountValidationUserADGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Валидация пользователя AD и генерация его токена
     */
    async accountValidationUserADGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountValidationUserADGetRaw(initOverrides);
    }

}
